<template>
  <div class="order-details">
    <div v-if="order">
      <el-card>
        <div class="header">
          <h3>{{orderStatus[order.pay_status]}}</h3>
          <h3 v-if="order.refund_status==-1" style="color: red;">退款中</h3>
          <h3 v-if="order.refund_status==1" style="color: red;">售后已完成</h3>

          <p>{{ order.create_time }}</p>
        </div>
        <el-divider></el-divider>
        <div class="user-info">
          <p>{{order.receiver_name}} {{ order.receiver_tel }}</p>
          <p>{{order.receiver_area }}{{order.receiver_address}}</p>
        </div>
        <el-divider></el-divider>

        <div class="product-info">
          <img :src="order.product_type_sku_img_url" alt="Product Image">
          <div>
            <div>{{ order.product_name }}</div>
            <div class="order-sku">{{ order.product_type_name}}</div>
            <div class="order-price">¥{{ order.order_price }}</div>
          </div>
        </div>
        <el-divider></el-divider>

        <div class="order-summary">
          <p>订单编号: {{ order.order_no }}</p>
          <p>下单时间: {{ order.order_time }}</p>
          <p>支付方式: {{ order.pay_style==0?'货到':order.pay_style==4?'支付宝':'微信' }}</p>
          <p>合计: ¥{{ order.order_total }}</p>
        </div>

        <div class="order_btn">
          <button v-if="order.pay_status==0" class="action-button" @click="orderInfoView(order,'pay')">立即支付</button>
          <!-- <button v-if="order.pay_status==0" class="action-button" @click="orderInfoView(order)">取消订单</button> -->
          <button v-if="order.pay_status==1 && order.refund_status==0" class="action-button" @click="orderInfoView(order,'after')">申请退款</button>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
  import {
    orderAfter,
    orderNowPay
  } from "../utils/api"

  export default {
    data() {
      return {
        order: null,
        orderStatus: {
          0: '待支付',
          1: '已支付',
          2: '已退款'
        }
      };
    },
    created() {
      console.log(this.$route.query)
      this.order = this.$route.query;
    },
    methods: {
      orderInfoView(order, type) {
        let that = this;
        switch(type){
          case 'after':
              this.$prompt('请输入申请原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
              }).then(({
                value
              }) => {
                  orderAfter({order_no:that.order.order_no}).then(res=>{

                    this.$notify({
                      title: '申请状态',
                      message: '已申请',
                      duration: 3000,
                      type:'success'
                    });
                    this.$router.replace({path:'/my'})
                  })
              }).catch(() => {

              });
            break;
          case 'pay':

            let params = {
              order_no:order.order_no
            }
            orderNowPay(params).then(res=>{
                let system = navigator.userAgent
                let isAndroid = system.indexOf('Android') > -1 || system.indexOf('Adr') > -1 // android终端
                let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
                if (isAndroid) {
                  //android终端
                  // window.open(res.data.pay_info)
                  // window.open(res.data.urlLink)
                  if(that.order.pay_source=='efpsalipay'){
                    window.open(res.data.codeUrl)
                  }else{
                    window.open(res.data.urlLink)
                  }

                } else if (isiOS) {
                  if(that.order.pay_source=='efpsalipay'){
                    window.location.href = res.data.codeUrl
                  }else{
                    window.location.href = res.data.urlLink
                  }
                  //ios终端
                  // window.location.href = res.data.pay_info
                  // window.location.href = res.data.urlLink
                }
                setTimeout(function() {
                   that.$router.replace({path:'/myorder',query:{id:1}})
                }, 2000);

              }, err => {

              })
            break;
        }
      }
    }
  };
</script>

<style scoped>
  .order-details {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }

  .header {
    /* text-align: center; */
    /* padding: 10px 0; */
  }

  .user-info,
  .product-info,
  .order-summary {
    /* padding: 10px 0; */
  }

  .product-info {
    display: flex;
    /* align-items: center; */
  }

  .product-info img {
    width: 100px;
    height: 100px;
    margin-right: 10px;
  }

  .refund-button {
    width: 100%;
    margin-top: 20px;
  }

  .order-sku {
    margin-top: 10px;
  }

  .order-price {
    margin-top: 30px;
    color: #ff1048;
  }

  .order_btn {
    display: flex;
    justify-content: flex-end;
  }

  .action-button {
    color: #ff0000;
    background-color: #fff;
    border: 1px solid #ff0000;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderInfo.vue